var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayNext1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5844 8.87928L15.2686 14.4056C15.1839 14.4797 15.1159 14.5711 15.0693 14.6736C15.0228 14.7761 14.9987 14.8875 14.9987 15.0001C14.9987 15.1127 15.0228 15.224 15.0693 15.3265C15.1159 15.4291 15.1839 15.5204 15.2686 15.5945L21.5844 21.1209C22.0952 21.5669 22.8942 21.2045 22.8942 20.5264V9.47375C22.8942 8.7948 22.0952 8.43322 21.5844 8.87928ZM12.9002 8.87928L6.58444 14.4056C6.49964 14.4797 6.43168 14.5711 6.38511 14.6736C6.33854 14.7761 6.31445 14.8875 6.31445 15.0001C6.31445 15.1127 6.33854 15.224 6.38511 15.3265C6.43168 15.4291 6.49964 15.5204 6.58444 15.5945L12.9002 21.1209C13.411 21.5669 14.21 21.2045 14.21 20.5264V9.47375C14.21 8.7948 13.411 8.43322 12.9002 8.87928Z",
    fill: "#093E59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayNext1);
export default __webpack_public_path__ + "static/media/play-next (1).ae19d3ed990288a48a5b18c0bf6fe48d.svg";
export { ForwardRef as ReactComponent };